import { DrEntity } from './dr-entity';
import { OrderedCodeSet } from './ordered-code-set';
import { TaggedEntity } from './tagged-entity';

export enum ViewType {
    CORPUS_SET = 'CORPUS_SET',
    WORKING_SET = 'WORKING_SET',
    CORPUS_SET_RESULT = 'CORPUS_SET_RESULT',
    WORKING_SET_RESULT = 'WORKING_SET_RESULT',
    TAG = 'TAG',
    GROUP = 'GROUP',
    CLUSTER = 'CLUSTER',
    CORPUS = 'CORPUS',
    CORPUS_RESULT = 'CORPUS_RESULT',
    EXPORT = 'EXPORT',
    MODEL = 'MODEL',
    WORKING_SET_DOCUMENT_LIST = 'WORKING_SET_DOCUMENT_LIST',
    DYNAMIC_FOLDER = 'DYNAMIC_FOLDER',
    CUSTODIAN = 'CUSTODIAN',
    UNASSIGNED_CUSTODIAN = 'UNASSIGNED_CUSTODIAN',
    UNASSIGNED_MEDIAID = 'UNASSIGNED_MEDIAID',
    UNASSIGNED_BATCH = 'UNASSIGNED_BATCH',
    REVIEW_BATCH = 'REVIEW_BATCH',
    REVIEW_BATCH_FOLDER = 'REVIEW_BATCH_FOLDER',
    CLASSIFIER = 'CLASSIFIER',
    MEDIAID = 'MEDIAID',
    BATCH = 'BATCH'
}

export class View extends DrEntity {
    name: string;
    description: string;
    documentCount: number;
    childViewCount: number;
    viewType: ViewType;
    taggedEntityList: Array<TaggedEntity>;
    createdBy: string;
    createdOn: number;
    sourceViewHandle: string;
    deDupeDocumentCount: number;
    priority: number;
    archived: boolean;
    orderedCodeSets: Array<OrderedCodeSet>;

    // off-model display values
    sampleSetCount: number;
    iconClass: string;
    iconColor: string;
    constructor(value?: Partial<View>) {
        super(value);
        if (value) {
            if (value.taggedEntityList) {
                value.taggedEntityList = value.taggedEntityList.map(tag => new TaggedEntity(tag));
            }
            if (value.attributes) {
                const samplesetcount = value.attributes.find(a => a.name === 'samplesetcount');
                if (samplesetcount) {
                    this.sampleSetCount = parseInt(samplesetcount.value, 10);
                }
                if (value.viewType === ViewType.TAG) {
                    this.iconClass = 'fa-tag';
                    const displayColor = value.attributes.find(a => a.name === 'displayValue');
                    if (displayColor) {
                        this.iconColor = displayColor.value;
                    }
                }
            }
            Object.assign(this, value);
        }
    }
}
